import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface GetCancelBookingRequestData {
  bookingNumber: string
  isCreateCreditPromocode: boolean
  isCancel: boolean
  cancellationReasonEnum: string
  note: string
}

export interface GetCancelBookingRequest extends Partial<AxiosRequestConfig> {
  params: GetCancelBookingRequestData
}

export interface GetCancelBookingData {
  creditedAmount: number | null
  description: string
  expiredDate: number | null
  isPromocodeCreated: boolean | null
  promoCode: string | null
  travelerName: string | null
}

export interface GetCancelBookingResponseData extends ResponseData {
  data: GetCancelBookingData
}

export interface GetCancelBookingResponse extends AxiosResponse {
  data: GetCancelBookingResponseData
}

export function getCancelBookingApi(
  {
    params,
    method = "post",
    url = `/booking/cancel-booking`,
    ...config
  }: GetCancelBookingRequest,
  axiosInstance: AxiosInstance,
): Promise<GetCancelBookingResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<GetCancelBookingResponse>
}
